var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatasearchSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.864,
    height: 28.864,
    viewBox: "0 0 36.864 36.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5825",
    d: "M0-682.665H36.864V-645.8H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g5811",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5813",
    transform: "translate(16.608 -654.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5815",
    d: "M0,0V4.014",
    transform: "translate(0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5817",
    transform: "translate(12.365 -654.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5819",
    d: "M0,0V4.014",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5821",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5823",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5829",
    transform: "translate(14.487 28.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5831",
    d: "M0,0V6.3",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5833",
    transform: "translate(28.62 -669.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5835",
    d: "M0,0H4.014",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5837",
    transform: "translate(28.62 -665.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5839",
    d: "M0,0H4.014",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5841",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5843",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5849",
    transform: "translate(28.78 15.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5851",
    d: "M0,0H6.427",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5853",
    transform: "translate(25.786 25.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5855",
    d: "M-173.167-119.652l.526.526a.432.432,0,0,1,0,.611l-2.444,2.444a.432.432,0,0,1-.611,0l-7.229-7.229a.432.432,0,0,1,0-.611l2.444-2.444a.432.432,0,0,1,.611,0l5.075,5.075",
    transform: "translate(183.052 126.482)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5857",
    transform: "translate(23.81 23.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5859",
    d: "M-26.707,0l2.564,2.565-1.527,1.527-2.561-2.561",
    transform: "translate(28.232)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5861",
    transform: "translate(27.262 27.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5863",
    d: "M-80.271-26.757-83.326-23.7l-1.527-1.527,3.055-3.055Z",
    transform: "translate(84.853 28.284)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5865",
    transform: "translate(0.54 0.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5867",
    d: "M-438.918-93.422a13.98,13.98,0,0,1,3.025,8.707,14.04,14.04,0,0,1-14.04,14.04,14.04,14.04,0,0,1-14.04-14.04,14.04,14.04,0,0,1,14.04-14.04,13.989,13.989,0,0,1,9.44,3.647",
    transform: "translate(463.972 98.754)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5869",
    transform: "translate(2.699 2.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5871",
    d: "M-52.327-346.5a11.575,11.575,0,0,1-2.986-7.9,11.939,11.939,0,0,1,11.88-11.88,11.893,11.893,0,0,1,11.88,11.88,11.893,11.893,0,0,1-11.88,11.88,12.169,12.169,0,0,1-7.2-2.427",
    transform: "translate(55.314 366.278)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5873",
    transform: "translate(8.28 8.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5875",
    d: "M0-5.045a.288.288,0,0,1,.288-.288H4.032a.288.288,0,0,1,.288.288V1.291H0Z",
    transform: "translate(0 5.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5877",
    transform: "translate(16.92 10.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5879",
    d: "M-75.68-68.112H-80v-3.6A.288.288,0,0,1-79.712-72h3.744a.288.288,0,0,1,.288.288Z",
    transform: "translate(80 72)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5881",
    transform: "translate(12.6 5.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5883",
    d: "M-75.68-163.973H-80v-9.072a.288.288,0,0,1,.288-.288h3.744a.288.288,0,0,1,.288.288Z",
    transform: "translate(80 173.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5885",
    transform: "translate(7.017 14.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5887",
    d: "M0,0H15.485",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5889",
    transform: "translate(8.845 17.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5891",
    d: "M0-57.732H2.852l1.214-2.174,1.6,4.534,2.1-5.655,1.289,3.3h2.911",
    transform: "translate(0 61.028)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasearchSmall);
export default __webpack_public_path__ + "static/media/datasearch_small.04068fbc5438b9b47eb9752e70f5b57e.svg";
export { ForwardRef as ReactComponent };